import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ChangeNoteIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ActualDateChange, PlannedDateToken, RequestDateToken, ValidationItem, ValidationSummary, ActualDateToken, PartialDelivery, GenFileUploads, SubSalesOrder, UserType, User, ChangeNoteDef } from '../../../shared/misc-classes';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { SubmitConfirmDialog } from '../../../dialogs/submit-confirm-dialog/submit-confirm-dialog';
import { DataPreviewDialog } from '../../../dialogs/data-preview-dialog/data-preview-dialog';
import { ConfigurationService } from '../../../shared/configuration.service';



@Component({
  selector: 'change-note',
  templateUrl: './change-note.component.html',
  styleUrls: ['./change-note.component.css']
})
export class ChangeNoteComponent implements OnInit,OnChanges {
 
  @Input() soLockObtained:boolean;
  @Input() changeNoteObj: ChangeNoteIP;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  disableForm: boolean = true;
  Hvr:any = {};

  public _SSOStatus = SSOStatus;
  _subsaleOrder :SubSalesOrder;
  userLogged_Id:string;
  userLogged_Name:string;
  userLogged_Type:UserType;
  userLogged:string;
  tmpUser : string;

  modifyReqDate: boolean = false;
  modifyPlanDate:boolean = false;
  inputDisableMessage:string = 'This form is not yet enabled';  
  currentLocation : string;
  readonlyAccess : boolean = false;
  filteredChangeNote : Array<ChangeNoteDef> = [];
  private productionCostEditRoles: Array<UserType> = [
    UserType.PRODUCTION,
    UserType.HOD_PRODUCTION,
    UserType.TESTING,
    UserType.HOD_TESTING
  ];

  constructor(public _dataService: DataService, public dialog: MatDialog, private _snackBar: MatSnackBar, private _configurationService: ConfigurationService) { }

  private getMergedEmailGroups(keys: string[]): string[] {
    const emails = new Set<string>();

    for (const key of keys || []) {
      this._configurationService
        .getEmailGroup(key)
        .forEach(email => emails.add(email));
    }

    return Array.from(emails);
  }

  isFinalStatus(cData: ChangeNoteDef): boolean {
    return cData.submittedStatus &&
      (cData.approvalStatus === 'Approved' ||
      cData.approvalStatus === 'Rejected' ||
      cData.approvalStatus === 'Cancelled');
  }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    this.userLogged_Id =  this._dataService.userId;
    this.userLogged_Name =  this._dataService.userName;
    this.userLogged_Type =  this._dataService.userType

    let location = window.location.href;
    let _tmp = location.split('/');
    this.currentLocation = _tmp[0]+"//"+_tmp[2]+"/";
    

    let _enggUsers = [UserType.ELECTRICAL_ENGINEERING, UserType.MECHANICAL_ENGINEERING, UserType.SUPER_ADMIN]
    if (_enggUsers.includes(this.userLogged_Type) == true) {
      switch (this.userLogged_Type) {
        case UserType.ELECTRICAL_ENGINEERING:
          this.tmpUser = 'Electrical Engineer';
          break;
        case UserType.MECHANICAL_ENGINEERING:
          this.tmpUser = 'Mechanical Engineer';
          break;
        case UserType.SUPER_ADMIN:
          this.tmpUser = 'Admin';
          break;
      }
    }

    let arr_ : Array<ChangeNoteDef> = this.changeNoteObj.changeData

    let _tmpCN_Comp: Array<ChangeNoteDef>=[];
    let _tmpCN_Sub: Array<ChangeNoteDef>=[];
    for (let i = 0; i < arr_.length; i++) {
      let sub = arr_[i].submittedStatus;
      let comp = arr_[i].completedStatus;
      if(sub == true && comp == true){
        _tmpCN_Comp.push(arr_[i]);
      }
      else if(sub == true && comp == false){
        _tmpCN_Sub.push(arr_[i]);
      }
    }
    let _tmpCN = _tmpCN_Sub.concat(_tmpCN_Comp)
    this.filteredChangeNote = _tmpCN;
    

    this.filteredChangeNote.forEach(cData => {
      if (this.isFinalStatus(cData)) {
        cData.originalTimeConsumed = cData.timeConsumed;
        cData.originalLabourRate = cData.labourRate;
        }
    });
  }

  ngOnChanges(){
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.changeNoteObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.changeNoteObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasChangeNoteEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else if (!this.changeNoteObj.isChangeNoteEditable) {
      this.inputDisableMessage = "This form is LOCKED and is NOT EDITABLE.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if(this._dataService.hasReadOnlyAccess){
      this.readonlyAccess = true;
    }
  }

  isProductionFatRole(): boolean {
    return this.productionCostEditRoles.includes(this.userLogged_Type);
  }

canEditProductionFields(cData: ChangeNoteDef): boolean {
  return !this.disableForm &&
         (this.isProductionFatRole() || this.userLogged_Type === UserType.SUPER_ADMIN) &&
         this.isFinalStatus(cData);
}

  isGeneralFieldDisabled(cData: ChangeNoteDef): boolean {
    if (this.isProductionFatRole()) {
      return true;
    }
    return this.disableForm || cData.submittedStatus;
  }

  isTimeLabourFieldDisabled(cData: ChangeNoteDef): boolean {
    if (this.isProductionFatRole()) {
      return !this.canEditProductionFields(cData);
    }
    // Admin can edit: new notes OR approved/rejected notes
    if (this.userLogged_Type === UserType.SUPER_ADMIN) {
      return !(!cData.submittedStatus || this.isFinalStatus(cData));
    }
    return this.disableForm || cData.submittedStatus;
  }

  canManageChangeNote(): boolean {
    return this.disableForm == false && this.isProductionFatRole() == false;
  }

 isValidProductionFieldValues(cData: ChangeNoteDef): boolean {
    const time = Number(cData.timeConsumed);
    const labour = Number(cData.labourRate);

    return !isNaN(time) && time > 0 &&
          !isNaN(labour) && labour > 0;
  }

  hasProductionFieldChanges(cData: ChangeNoteDef): boolean {
    // For new records (original values not yet set), consider changed if valid values are entered
    if (cData.originalTimeConsumed === null || cData.originalTimeConsumed === undefined ||
        cData.originalLabourRate === null || cData.originalLabourRate === undefined) {
      return this.isValidProductionFieldValues(cData);
    }

    const currentTime = Number(cData.timeConsumed);
    const currentLabour = Number(cData.labourRate);
    const originalTime = Number(cData.originalTimeConsumed);
    const originalLabour = Number(cData.originalLabourRate);

    return currentTime !== originalTime || currentLabour !== originalLabour;
  }

  canEnableProductionSaveButton(cData: ChangeNoteDef): boolean {
    return this.canEditProductionFields(cData) &&
           this.hasProductionFieldChanges(cData) &&
           this.isValidProductionFieldValues(cData);
  }

  saveProductionCostUpdate(i: number) {
    if (!this.canEnableProductionSaveButton(this.filteredChangeNote[i])) {
      return;
    }
    this.saveSso(false);
    this.filteredChangeNote[i].originalTimeConsumed = this.filteredChangeNote[i].timeConsumed;
    this.filteredChangeNote[i].originalLabourRate = this.filteredChangeNote[i].labourRate;
    this._snackBar.open('Change Note Details fields updated successfully.', 'Dismiss', {
      duration: 4000,
    });
  }

  isValidNoOfPanels(_noOfPanels: any): boolean {
    if (_noOfPanels === null || _noOfPanels === undefined || _noOfPanels === '') {
      return false;
    }
    const _numVal = Number(_noOfPanels);
    return isNaN(_numVal) == false && _numVal >= 0;
  }

  checkAccess(i){
    return this.filteredChangeNote[i].userEnable(this.userLogged_Id);
  }
  checkCancelAccess(i){
    if(this.userLogged_Id == this.filteredChangeNote[i].userNameId){
      return true;
    }
     else return false;
  }
  addNewData() {
    // this.changeNoteObj.addChangeNoteData(this.userLogged_Id, this.userLogged_Name, this.tmpUser);
    this.filteredChangeNote.unshift(new ChangeNoteDef(new Date(new Date().toDateString()), this.userLogged_Id, this.userLogged_Name, this.tmpUser, "",
		"", null, "", "", "", null, "", null, new GenFileUploads([]), "", "", "", 
		false, "", "", "", null, "", "", false, "", "", false));
  }
  getUserName(){
   return this._dataService.userName;
  }
  getApproverUserName(_userEmail){
    let ap1 = this._dataService.getApproverL1Name(_userEmail);
    let ap2 = this._dataService.getApproverL2Name(_userEmail);
    if(ap1){
      return ap1;
    }
    else if(ap2){
      return ap2;
    }
    else return "-";
  }
  getSoNo(){
    return this.changeNoteObj.parentSORef.marketingIP.salesOrderNo + " - " + this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo;
   }
  getCustName(){
    return this.changeNoteObj.parentSORef.marketingIP.customerName;
  }
  getUserType(i){
    return this.filteredChangeNote[i].userType;
  }
  getCounterNo(_type){
    let _counter = 0;
    for (let i = 0; i < this.filteredChangeNote.length; i++) {
      let e = this.filteredChangeNote[i].userType;
      if(e == _type){
        _counter++;
      }      
    }
    return _counter;
  }
  removeData(_index:number){
    this.filteredChangeNote.splice(_index, 1);
  }
  onDespChange(_event, i){
    this.filteredChangeNote[i].description = _event.target.value;
  }
  onIssueDChange(_event, i){
    this.filteredChangeNote[i].issueDetails = _event.target.value;
  }
  onCorActChange(_event, i){
    this.filteredChangeNote[i].correctiveAction = _event.target.value;
  }
  onPrevActChange(_event, i){
    this.filteredChangeNote[i].preventiveAction = _event.target.value;
  }
  onCommChange(_event, i){
    this.filteredChangeNote[i].comments = _event.target.value;
  }
  CNUploadsFileManagerClick(_evnt,i){
    _evnt.stopPropagation();//stop ref
    this.filteredChangeNote[i].fileUploadCN.disableUpload = this.filteredChangeNote[i].submittedStatus
    this.filteredChangeNote[i].fileUploadCN.headerStr = "Change note Upload" + " - " + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.changeNoteObj.parentSubSORef.subOrderNoId;
    this.showFileManager.emit(this.filteredChangeNote[i].fileUploadCN);
  }
  DescpDataManagerClick(_data,i){
    let _tempData = {"title":"Description", "message": _data};
    let dialogRef = this.dialog.open(DataPreviewDialog, {
      width: 40 + '%',
      data: _tempData
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
      this.filteredChangeNote[i].description = _tempData.message;
      }});
  }
  IssueDataManagerClick(_data,i){
    let _tempData = {"title":"Issue Details", "message": _data};
    let dialogRef = this.dialog.open(DataPreviewDialog, {
      width: 40 + '%',
      data: _tempData
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
      this.filteredChangeNote[i].issueDetails = _tempData.message;
      }});
  }
  submitForApproval(i){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
      width: 40 + '%',
      data: { message: "Do you want to Submit the Change Note for Approval ?" }
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
    this.filteredChangeNote[i].submittedStatus = true;
    let _tempType = this.getUserType(i).substring(0,1);
    let _tmpNo = this.getCounterNo(this.filteredChangeNote[i].userType);
    this.filteredChangeNote[i].changeNoteNo = _tempType + _tmpNo;

    let _data = this.mailBody(i);    
    
    this.saveSso(false);
  
    this._dataService.sendaisc40(_data).subscribe((_docid: any) => {
      if (_docid.status != "OK") {
        this._snackBar.open("Failed to Send Mail Notification", "Dismiss", {
          duration: 6000,
        });   
      }
      else {
        this._snackBar.open("Mail Notification Sent Successfully", "Dismiss", {
          duration: 6000,
        });
        
      }
    });
      }
      else{

      }
    });
  }
  approvedClick(i){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
      width: 40 + '%',
      data: { message: "Do you want to Approve <strong> Change Note : "+ (this.filteredChangeNote[i].changeNoteNo) +"</strong> ?" }
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
    this.filteredChangeNote[i].completedDate = new Date(new Date().toDateString());
    this.filteredChangeNote[i].approvalStatus = "Approved";
    this.filteredChangeNote[i].approvedBy = this._dataService.userId;
    this.filteredChangeNote[i].completedStatus = true;
    this.filteredChangeNote[i].originalTimeConsumed = this.filteredChangeNote[i].timeConsumed;
    this.filteredChangeNote[i].originalLabourRate = this.filteredChangeNote[i].labourRate;

    this.saveSso(false);

    let _data = this.mailBodyApproval(i);

    this._dataService.sendaisc40(_data).subscribe((_docid: any) => {
      if (_docid.status != "OK") {
        this._snackBar.open("Failed to Send Mail Notification", "Dismiss", {
          duration: 6000,
        });   
      }
      else {
        this._snackBar.open("Mail Notification Sent Successfully", "Dismiss", {
          duration: 6000,
        });
        
      }
    });
      }
      else{

      }
    });
  }
  rejectedClick(i){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
      width: 40 + '%',
      data: { message: "Do you want to Reject <strong> Change Note : "+ (this.filteredChangeNote[i].changeNoteNo) +"</strong> ?" }
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
    this.filteredChangeNote[i].completedDate = new Date(new Date().toDateString());
    this.filteredChangeNote[i].approvalStatus = "Rejected";
    this.filteredChangeNote[i].approvedBy = this._dataService.userId;
    this.filteredChangeNote[i].completedStatus = true;
    this.filteredChangeNote[i].originalTimeConsumed = this.filteredChangeNote[i].timeConsumed;
    this.filteredChangeNote[i].originalLabourRate = this.filteredChangeNote[i].labourRate;

    this.saveSso(false);

    let _data = this.mailBodyRejection(i);

    this._dataService.sendaisc40(_data).subscribe((_docid: any) => {
      if (_docid.status != "OK") {
        this._snackBar.open("Failed to Send Mail Notification", "Dismiss", {
          duration: 6000,
        });   
      }
      else {
        this._snackBar.open("Mail Notification Sent Successfully", "Dismiss", {
          duration: 6000,
        });
        
      }
    });
      }
      else{

      }
    });
  }
  cancelChangeNoteApproval(i){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
      width: 40 + '%',
      data: { message: "Do you want to Cancel <strong> Change Note : "+ (this.filteredChangeNote[i].changeNoteNo) +"</strong> ?" }
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
    this.filteredChangeNote[i].completedDate = new Date(new Date().toDateString());
    this.filteredChangeNote[i].approvalStatus = "Cancelled";
    this.filteredChangeNote[i].completedStatus = true;

    this.saveSso(false);

    let _data = this.mailBodyCancelled(i);

    this._dataService.sendaisc40(_data).subscribe((_docid: any) => {
      if (_docid.status != "OK") {
        this._snackBar.open("Failed to Send Mail Notification", "Dismiss", {
          duration: 6000,
        });   
      }
      else {
        this._snackBar.open("Mail Notification Sent Successfully", "Dismiss", {
          duration: 6000,
        });
        
      }
    });
      }
      else{

      }
    });
  }
  getSubmittedData(){
    let _tmpArray: Array<ChangeNoteDef>=[];
    for (let i = 0; i < this.filteredChangeNote.length; i++) {
      let ele = this.filteredChangeNote[i].submittedStatus;
      if(ele == true){
        _tmpArray.push(this.filteredChangeNote[i]);
      }
    }
    this.changeNoteObj.changeData = _tmpArray;

  }

  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
   
    this.getSubmittedData();

    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_ChangeData),
          null,
          ssoSubmitTo
        ));
    }
  }

  showSubmitValidation(i) {
    let _validList: Array<ValidationItem> = [];
    _validList.push(new ValidationItem("No. of Panels Affected ", this.isValidNoOfPanels(this.filteredChangeNote[i].noOfPanels), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Nature of Issues ", (this.filteredChangeNote[i].natureOfIssuesId ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Amount Impact ", (this.filteredChangeNote[i].amountImpact ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Details of Excess Material ", (this.filteredChangeNote[i].excessMatDetails ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Change Note Type ", (this.filteredChangeNote[i].changeNoteTypeId ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Remark ", (this.filteredChangeNote[i].remark ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Description ", (this.filteredChangeNote[i].description ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Uploads ", (this.filteredChangeNote[i].fileUploadCN.FileArray.length > 0 ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Issue Details	", (this.filteredChangeNote[i].issueDetails ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Corrective Action ", (this.filteredChangeNote[i].correctiveAction ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Preventive Action ", (this.filteredChangeNote[i].preventiveAction ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Approver Name L1 ", (this.filteredChangeNote[i].approverNameL1 ? true : false), " required to Submit for Approval."));
    _validList.push(new ValidationItem("Approver Name L2 ", (this.filteredChangeNote[i].approverNameL2 ? true : false), " required to Submit for Approval."));

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }
  readyForSubmit(i): boolean {
    if (this.isValidNoOfPanels(this.filteredChangeNote[i].noOfPanels) && this.filteredChangeNote[i].natureOfIssuesId && this.filteredChangeNote[i].amountImpact &&
      this.filteredChangeNote[i].excessMatDetails && this.filteredChangeNote[i].changeNoteTypeId && this.filteredChangeNote[i].remark &&
      this.filteredChangeNote[i].description &&
      this.filteredChangeNote[i].fileUploadCN.FileArray.length > 0 && this.filteredChangeNote[i].issueDetails && this.filteredChangeNote[i].correctiveAction &&
      this.filteredChangeNote[i].preventiveAction && this.filteredChangeNote[i].approverNameL1 && this.filteredChangeNote[i].approverNameL2) {
      return true;
    }
    else {
      return false;
    }
  }

  mailBody(i){
    let mailData = {};
    let _tmpBody = "<p style='font-size:14px';>Dear Sir, <br>"+ "Request you to approve below change note for subject order.<br>";
    _tmpBody += "<br><strong> Issues :</strong> <br>"+ this.filteredChangeNote[i].issueDetails +"<br><br><strong>Corrective Action : </strong><br>"+this.filteredChangeNote[i].correctiveAction+"<br><br><strong> Preventive Action : </strong><br>"+this.filteredChangeNote[i].preventiveAction+"<br><br></p>";
    let _header = "<table style='border-collapse: collapse;font-size:14px'> <thead> "+ "<tr>"+ 
        "<th style='width:6%;border:1px solid';>Date</th>"+
        "<th style='border:1px solid';>Sale Order No</th>"+
        "<th style='border:1px solid';>Customer Name</th>"+
        "<th style='border:1px solid';>EDE/ ME/Other Name</th>"+
        "<th style='width:7%;border:1px solid';>Change Note No.</th>"+
        "<th style='border:1px solid';>Description</th>"+
        "<th style='border:1px solid';>No of Panels affected</th>"+
        "<th style='border:1px solid';>Nature of issues</th>"+
        "<th style='border:1px solid';>Amount</th>"+
        "<th style='border:1px solid';>Total Labour Cost=Labour Rate*Time / Hours Consumed</th>"+
        "<th style='border:1px solid';>Total CN Cost= Total Labour Cost + Amount Impact</th>"+
        "<th style='border:1px solid';>Details of excess materials</th>"+
        "<th style='border:1px solid';>Change Note Type</th>"+
        "<th style='border:1px solid';>Remark</th>"+
        "</tr></thead>";
    let _amt : any= this.filteredChangeNote[i].amountImpact != null ? this.filteredChangeNote[i].amountImpact : ""; 

    let _tmp1 : any = this.filteredChangeNote[i].timeConsumed != null ? this.filteredChangeNote[i].timeConsumed : ""; 
    let _lab : any= !isNaN(this.filteredChangeNote[i].labourRate * _tmp1) ? (this.filteredChangeNote[i].labourRate * _tmp1) : ""; 

    let _cncst =  !isNaN(_lab) ? (_lab + _amt) : _amt;
    
    let _body = "<tr>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getDateFormat(this.filteredChangeNote[i].createdDate)+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.customerName+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].userName + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+"-"+this.filteredChangeNote[i].changeNoteNo+ "</td>" +
      "<td style='border:1px solid';>" + this.filteredChangeNote[i].description + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].noOfPanels + "</td>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getNatureOfIssuesTypeName(this.filteredChangeNote[i].natureOfIssuesId) + "</td>" +
      "<td align='center' style='border:1px solid';>" + _amt + "</td>" +
      "<td align='center' style='border:1px solid';>" + _lab + "</td>" +
      "<td align='center' style='border:1px solid';>" + _cncst + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].excessMatDetails + "</td>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getChangeNoteTypeName(this.filteredChangeNote[i].changeNoteTypeId) + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].remark + "</td>" +
      "</tr></table>";

    let _tmpLink = "sales/edit/"+this.changeNoteObj.parentSORef.salesOrderId+"/changenote/"+this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo;
    let _appLink = "<br><br> Please click <a href='"+this.currentLocation+_tmpLink+"'>HERE</a> to approve/reject the Change Note.<br>Note: If not Authenticated, kindly click the above link again to approve/reject change note.";
      _tmpBody+= _header +_body + _appLink;

    const changeNoteCcList = this.getMergedEmailGroups(['CHANGE_NOTE_CC']);
    mailData = { "toMail": [this.filteredChangeNote[i].approverNameL1], "mailBody": _tmpBody,
      "ccMail":[this.filteredChangeNote[i].approverNameL2,this.filteredChangeNote[i].userNameId,
      ...changeNoteCcList], 
      "subMail": "Change Note : "+ this._dataService.getChangeNoteTypeName(this.filteredChangeNote[i].changeNoteTypeId)+" : Sale Order No : " + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo + "-" + this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo + "_" + this.changeNoteObj.parentSORef.marketingIP.customerName,
    "filenames": [], "trigger": "", "status": "","imageFile":null};

    return mailData;
  }

  mailBodyApproval(i){
    let mailData = {};
    let _tmpBody = "<p style='font-size:14px';>Dear  "+this.filteredChangeNote[i].userName +", <br> Your request for change note approval for subject order has a new update.<br>";
    _tmpBody += "<br><strong> Change Note No. :</strong> <br>"+ this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+"-"+this.filteredChangeNote[i].changeNoteNo+"<br><br><strong> Approval Status :</strong> <br>"+ this.filteredChangeNote[i].approvalStatus+"<br><br><strong> Approver Comments : </strong><br>"+this.filteredChangeNote[i].comments+"<br></p>";
    
    let _header = "<table style='border-collapse: collapse;font-size:14px'> <thead> "+ "<tr>"+ 
        "<th style='width:6%;border:1px solid';>Date</th>"+
        "<th style='border:1px solid';>Sale Order No</th>"+
        "<th style='border:1px solid';>Customer Name</th>"+
        "<th style='border:1px solid';>EDE/ ME/Other Name</th>"+
        "<th style='width:7%;border:1px solid';>Change Note No.</th>"+
        "<th style='border:1px solid';>Description</th>"+
        "<th style='border:1px solid';>No of Panels affected</th>"+
        "<th style='border:1px solid';>Nature of issues</th>"+
        "<th style='border:1px solid';>Amount</th>"+
        "<th style='border:1px solid';>Total Labour Cost=Labour Rate*Time / Hours Consumed</th>"+
        "<th style='border:1px solid';>Total CN Cost= Total Labour Cost + Amount Impact</th>"+
        "<th style='border:1px solid';>Details of excess materials</th>"+
        "<th style='border:1px solid';>Change Note Type</th>"+
        "<th style='border:1px solid';>Remark</th>"+
        "</tr></thead>";
    let _amt : any= this.filteredChangeNote[i].amountImpact != null ? this.filteredChangeNote[i].amountImpact : ""; 

    let _tmp1 : any = this.filteredChangeNote[i].timeConsumed != null ? this.filteredChangeNote[i].timeConsumed : ""; 
    let _lab : any= !isNaN(this.filteredChangeNote[i].labourRate * _tmp1) ? (this.filteredChangeNote[i].labourRate * _tmp1) : ""; 

    let _cncst =  !isNaN(_lab) ? (_lab + _amt) : _amt;
    
    let _body = "<tr>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getDateFormat(this.filteredChangeNote[i].createdDate)+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.customerName+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].userName + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+"-"+this.filteredChangeNote[i].changeNoteNo+ "</td>" +
      "<td style='border:1px solid';>" + this.filteredChangeNote[i].description + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].noOfPanels + "</td>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getNatureOfIssuesTypeName(this.filteredChangeNote[i].natureOfIssuesId) + "</td>" +
      "<td align='center' style='border:1px solid';>" + _amt + "</td>" +
      "<td align='center' style='border:1px solid';>" + _lab + "</td>" +
      "<td align='center' style='border:1px solid';>" + _cncst + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].excessMatDetails + "</td>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getChangeNoteTypeName(this.filteredChangeNote[i].changeNoteTypeId) + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].remark + "</td>" +
      "</tr></table>";
    
    let _tmpLink = "sales/edit/"+this.changeNoteObj.parentSORef.salesOrderId+"/changenote/"+this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo;
    let _appLink = "<br><br> Please click <a href='"+this.currentLocation+_tmpLink+"'>HERE</a> to view the change note";
      _tmpBody+= _header +_body + _appLink;

    const approvalCcList = this.getMergedEmailGroups(['CHANGE_NOTE_CC', 'AIS_C50_GROUP', 'AIS_C40_GROUP']);

    mailData = { "toMail": [this.filteredChangeNote[i].userNameId], "mailBody": _tmpBody, 
      "ccMail":[this.filteredChangeNote[i].approverNameL1,this.filteredChangeNote[i].approverNameL2,
      ...approvalCcList], 
      "subMail": "Change Note : "+ this._dataService.getChangeNoteTypeName(this.filteredChangeNote[i].changeNoteTypeId)+" : Sale Order No : " + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo + "-" + this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo + "_" + this.changeNoteObj.parentSORef.marketingIP.customerName + " - "+ this.filteredChangeNote[i].approvalStatus,
    "filenames": [], "trigger": "", "status": "","imageFile":null};

    return mailData;
  }

  mailBodyRejection(i){
    let mailData = {};
    let _tmpBody = "<p style='font-size:14px';>Dear  "+this.filteredChangeNote[i].userName +", <br> Your request for change note approval for subject order has a new update.<br>";
    _tmpBody += "<br><strong> Change Note No. :</strong> <br>"+ this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+"-"+this.filteredChangeNote[i].changeNoteNo+"<br><br><strong> Approval Status :</strong> <br>"+ this.filteredChangeNote[i].approvalStatus+"<br><br><strong> Approver Comments : </strong><br>"+this.filteredChangeNote[i].comments+"<br></p>";
    let _tmpLink = "sales/edit/"+this.changeNoteObj.parentSORef.salesOrderId+"/changenote/"+this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo;
    let _appLink = "<br><br> Please click <a href='"+this.currentLocation+_tmpLink+"'>HERE</a> to view the change note";
      _tmpBody+= _appLink;

    const changeNoteCcList = this.getMergedEmailGroups(['CHANGE_NOTE_CC']);

    mailData = { "toMail": [this.filteredChangeNote[i].userNameId], "mailBody": _tmpBody, 
      "ccMail":[this.filteredChangeNote[i].approverNameL1,this.filteredChangeNote[i].approverNameL2,
      ...changeNoteCcList], 
      "subMail": "Change Note : "+ this._dataService.getChangeNoteTypeName(this.filteredChangeNote[i].changeNoteTypeId)+" : Sale Order No : " + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo + "-" + this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo + "_" + this.changeNoteObj.parentSORef.marketingIP.customerName + " - "+ this.filteredChangeNote[i].approvalStatus,
    "filenames": [], "trigger": "", "status": "","imageFile":null};

    return mailData;
  }

  mailBodyCancelled(i){
    let mailData = {};
    let _tmpBody = "<p style='font-size:14px';>Dear Sir, <br><br>"+ "This is to notify the cancellation of change note for "+ this.changeNoteObj.parentSORef.marketingIP.salesOrderNo + "-" + this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo + "_" + this.changeNoteObj.parentSORef.marketingIP.customerName + ".<br>";
    _tmpBody += "Kindly ignore the approval request of "+ this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+"-"+this.filteredChangeNote[i].changeNoteNo +"<br><br><strong>Reason for Cancellation : </strong><br>"+this.filteredChangeNote[i].cancelReason+"<br><br>";
    _tmpBody += "------------------------------------------------------------------<br>Reference information of the Change Note as below :<br><br>";
    _tmpBody += "<br><strong> Issues :</strong> <br>"+ this.filteredChangeNote[i].issueDetails +"<br><br><strong>Corrective Action : </strong><br>"+this.filteredChangeNote[i].correctiveAction+"<br><br><strong> Preventive Action : </strong><br>"+this.filteredChangeNote[i].preventiveAction+"<br><br></p>";
    let _header = "<table style='border-collapse: collapse;font-size:14px'> <thead> "+ "<tr>"+ 
        "<th style='width:6%;border:1px solid';>Date</th>"+
        "<th style='border:1px solid';>Sale Order No</th>"+
        "<th style='border:1px solid';>Customer Name</th>"+
        "<th style='border:1px solid';>EDE/ ME/Other Name</th>"+
        "<th style='width:7%;border:1px solid';>Change Note No.</th>"+
        "<th style='border:1px solid';>Description</th>"+
        "<th style='border:1px solid';>No of Panels affected</th>"+
        "<th style='border:1px solid';>Nature of issues</th>"+
        "<th style='border:1px solid';>Amount</th>"+
        "<th style='border:1px solid';>Total Labour Cost=Labour Rate*Time / Hours Consumed</th>"+
        "<th style='border:1px solid';>Total CN Cost= Total Labour Cost + Amount Impact</th>"+
        "<th style='border:1px solid';>Details of excess materials</th>"+
        "<th style='border:1px solid';>Change Note Type</th>"+
        "<th style='border:1px solid';>Remark</th>"+
        "</tr></thead>";
    let _amt : any= this.filteredChangeNote[i].amountImpact != null ? this.filteredChangeNote[i].amountImpact : ""; 

    let _tmp1 : any = this.filteredChangeNote[i].timeConsumed != null ? this.filteredChangeNote[i].timeConsumed : ""; 
    let _lab : any= !isNaN(this.filteredChangeNote[i].labourRate * _tmp1) ? (this.filteredChangeNote[i].labourRate * _tmp1) : ""; 

    let _cncst =  !isNaN(_lab) ? (_lab + _amt) : _amt;
    
    let _body = "<tr>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getDateFormat(this.filteredChangeNote[i].createdDate)+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.customerName+ "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].userName + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo+"-"+this.filteredChangeNote[i].changeNoteNo+ "</td>" +
      "<td style='border:1px solid';>" + this.filteredChangeNote[i].description + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].noOfPanels + "</td>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getNatureOfIssuesTypeName(this.filteredChangeNote[i].natureOfIssuesId) + "</td>" +
      "<td align='center' style='border:1px solid';>" + _amt + "</td>" +
      "<td align='center' style='border:1px solid';>" + _lab + "</td>" +
      "<td align='center' style='border:1px solid';>" + _cncst + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].excessMatDetails + "</td>" +
      "<td align='center' style='border:1px solid';>" + this._dataService.getChangeNoteTypeName(this.filteredChangeNote[i].changeNoteTypeId) + "</td>" +
      "<td align='center' style='border:1px solid';>" + this.filteredChangeNote[i].remark + "</td>" +
      "</tr></table>";

    let _tmpLink = "sales/edit/"+this.changeNoteObj.parentSORef.salesOrderId+"/changenote/"+this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo;
    let _appLink = "<br><br> Please click <a href='"+this.currentLocation+_tmpLink+"'>HERE</a> to approve/reject the Change Note.<br>Note: If not Authenticated, kindly click the above link again to approve/reject change note.";
      _tmpBody+= _header +_body + _appLink;

    const changeNoteCcList = this.getMergedEmailGroups(['CHANGE_NOTE_CC']);

    mailData = { "toMail": [this.filteredChangeNote[i].approverNameL1], "mailBody": _tmpBody, 
      "ccMail":[this.filteredChangeNote[i].approverNameL2,this.filteredChangeNote[i].userNameId,
      ...changeNoteCcList], 
      "subMail": "Change Note : "+ this._dataService.getChangeNoteTypeName(this.filteredChangeNote[i].changeNoteTypeId)+" : Sale Order No : " + this.changeNoteObj.parentSORef.marketingIP.salesOrderNo + "-" + this.changeNoteObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo + "_" + this.changeNoteObj.parentSORef.marketingIP.customerName + " - "+ this.filteredChangeNote[i].approvalStatus,
    "filenames": [], "trigger": "", "status": "","imageFile":null};

    return mailData;
  }
}
